/*
 * 商户相关API
 */
import request from '@/utils/request'

/**
 * 获取当前用户可见的商户列表（分页）
 * 说明：后端会根据当前登录用户在服务端进行数据范围过滤
 */
export function getMyBusinessList(params = {}) {
  const payload = {
    pageNo: 1,
    pageSize: 1,
    ...params
  }
  return request({
    url: '/market/business/page',
    method: 'post',
    data: payload
  })
}

/**
 * 根据用户ID获取其所属商户（后端已按管理员过滤，返回第一条）
 */
export function getBusinessByUser(userId) {
  return request({
    url: '/market/business/by-user',
    method: 'get',
    params: { userId }
  })
}

/**
 * 商户充值
 * account: WALLET|GIFTED，默认 WALLET
 */
export function rechargeMyBusiness(businessId, amount, account = 'WALLET') {
  return request({
    url: '/market/business/recharge',
    method: 'post',
    params: { businessId, amount, account }
  })
}

/**
 * 创建商户充值记录并生成支付订单
 * @param {Object} data - 充值请求参数
 * @param {string} data.businessId - 商户ID
 * @param {number} data.amount - 充值金额（元）
 * @param {string} data.payChannel - 支付渠道（H5_SCAN_CODE, WECHAT_PUBLIC_ACCOUNT, WECHAT_MINI_PROGRAM 等）
 * @param {string} data.openId - 微信openId（微信支付时必填）
 * @param {string} data.orderType - 订单类型（MERCHANTRE_CHARGE_FEE 或 ROAD_MERCHANTRE_CHARGE_FEE）
 * @param {string[]} data.parkIds - 场库ID列表（可选）
 * @param {string[]} data.roadIds - 道路ID列表（可选）
 * @param {string} data.attach - 附加数据（可选）
 * @returns {Promise}
 */
export function createRechargeRecordAndPayment(data) {
  return request({
    url: '/market/business/recharge/create',
    method: 'post',
    data
  })
}

/**
 * 更新商户钱包余额
 * 仅传递需更新字段即可
 */
export function updateBusinessWalletBalance (payload) {
  return request({
    url: '/market/business/update',
    method: 'post',
    data: payload
  })
}

/**
 * 兜底：获取商户简单列表（不分页）
 * 已迁移到 MyBusinessController: POST /market/business/list
 */
export function getBusinessListFallback() {
  return request({
    url: '/market/business/list',
    method: 'post',
    data: {}
  })
}

/**
 * 获取商户管理员列表
 * @param {string} businessId 商户ID
 * @returns {Promise} 返回管理员列表
 */
export function getBusinessAdminList(businessId) {
  return request({
    url: '/market/business/admin/list',
    method: 'get',
    params: { businessId }
  })
}

/**
 * 创建商户充值记录
 * @param {Object} data - 充值记录数据
 * @returns {Promise}
 */
export function createMerchantRechargeRecord(data) {
  return request({
    url: '/market/api/marketing/merchant-recharge-record',
    method: 'post',
    data
  })
}

/**
 * 获取商户详情
 * @param {string} businessId - 商户ID
 * @returns {Promise} 返回商户详情
 */
export function getMyBusinessDetail(businessId) {
  return request({
    url: '/market/business/detail',
    method: 'get',
    params: { businessId }
  })
}

/**
 * 根据商户编码获取商户详情
 * @param {string} businessCode - 商户编码
 * @returns {Promise} 返回商户详情
 */
export function getMyBusinessDetailByCode(businessCode) {
  return request({
    url: '/market/business/detail-by-code',
    method: 'get',
    params: { businessCode }
  })
}


